<script>
import { Line } from "vue-chartjs";

export default {
	name: "TempGraph",
	extends: Line,
	props: ["data"],
	methods: {
		getLabelsX() {
			let ret = [];
			for (let item in this.data){
				ret.push(parseFloat(Object.keys(this.data[item])));
			}

			console.log("Data X", this.data);
			console.log(`Returning X`, ret);

			return ret;
			/*
			let ret = [];
			for (let key in this.data){
				ret.push(key);
			}
			return ret;
			*/
		},
		getLabelsY() {
			let ret = [];
			for (let item in this.data){
				ret.push(parseFloat(Object.values(this.data[item])));
			}

			console.log("Data Y", this.data);
			console.log(`Returning Y`, ret);
			return ret;
			/*
			let ret = [];
			for (let key in this.data){
				ret.push(parseFloat(this.data[key]));
			}
			return ret;
			*/
		},
	},
	watch: {
		data : function(){
			this.renderChart(this.chartdata, this.options);
		}
	},
	computed: {
		chartdata() {
			return {
				labels: this.getLabelsX(),
				datasets: [
					{
						label: "Vývoj teploty",
						borderColor: "rgb(136, 185, 235)",
						data: this.getLabelsY(),
					},
				],
			};
		},
		options() {
			return {
				animation: false,
				responsive: true,
				tooltips: {
					callbacks: {
						label: function(tooltipItem) {
							return tooltipItem.yLabel + "°C";
						},
					},
				},
				scales: {
					yAxes: [
						{
							ticks: {
								callback: (value) => {
									return `${value}°C`;
								},
							},
						},
					],
					xAxes: [
						{
							ticks: {
								maxRotation: 80,
								minRotation: 80,
								callback: (value) => {
									return `${value} hod`;
								},
							},
							scaleLabel: {
								display: true,
							},
							gridLines: {
								display: false,
							},
						},
					],
				},
			};
		},
	},
	mounted() {
		this.renderChart(this.chartdata, this.options);
	},
};
</script>
